import type from "./type";

import {
  GetAllShortcuts,
  loginApiHandle,
  PostUserProfileApiHandle,
  getSingleUser,
  exitStocks,
  resetStocks,
  manageUserSettingHandle,
  dashboardStocksTagsHandle,
} from "../../service/UserIndex";
import Index from "../../container/Index";
// import Index from "../../Index";

// User Login Function
const UserLogin = (
  payload,
  navigate,
  getWatchList,
  setUser,
  setDisable,
  setError,
  setTheme
) => {
  return async function (dispatch) {
    loginApiHandle(payload).then((data) => {
      if (data.status === 200) {
        dispatch({
          type: type.USER_LOGIN_SUCCESS,
          payload: { ...data },
        });
        localStorage.setItem("token", data.data.token);
        sessionStorage.setItem("token", data.data.token);
        localStorage.setItem("default-theme", data?.data?.settings?.theme);
        sessionStorage.setItem("default-theme", data?.data?.settings?.theme);

        const themeTitle =
          data?.data?.settings?.theme?.toLowerCase() || "light";
        document?.body?.classList?.remove(`select-light-theme`);
        document?.body?.classList?.remove(`select-medium-theme`);
        document?.body?.classList?.remove(`select-dark-theme`);
        document?.body?.classList?.add(`select-${themeTitle}-theme`);

        const innerDiv = document.querySelector("#root > div");
        const theme = data?.data?.settings?.theme || "Light";
        if (innerDiv) {
          innerDiv?.classList?.remove(`theme-Light`);
          innerDiv?.classList?.remove(`theme-Medium`);
          innerDiv?.classList?.remove(`theme-Dark`);
          innerDiv?.classList?.add(`theme-${theme}`);
        }

        // getWatchList(data?.data);
        // Index.toast.success(data.message);
        setTimeout(() => {
          navigate("user/dashboard");
          setDisable(false);
        }, 1000);
        dispatch(getAllShortcuts(data.data.token));
        getUserSettings(
          dispatch,
          data?.data?.token,
          setTheme,
          data?.data?.settings
        );
        const loginData = data?.data;
        Index.DataService(localStorage.getItem("token"))
          .get(Index.Api.admin.getAllIndex, { params: { isActive: true } })
          .then((res) => {
            if (res.data?.status === 200) {
              let { data } = res.data;
              if (data?.length) {
                dispatch(
                  manageScript({
                    market: data[0]?.category,
                    script: data[0]?.indexName,
                  })
                );
                dispatch(getWishListData(data?.[0]?.stocks || []));
                // dispatch(setGridViewStore({ column: 1, row: 1 }));
              }
              const stocks = data?.[0]?.stocks ?? [];
              getWatchList(loginData, stocks);
            }
          })
          .catch((error) => {
            console.error(error.message);
          });
      } else {
        dispatch({ type: type.USER_ERROR_HANDLER, payload: data });
        setTimeout(() => {
          setDisable(false);
        }, 1000);

        setUser({
          email: "",
          password: "",
        });
        // Index.toast.error(data.message);
        setError(data.message);
      }
    });
  };
};

const UserLogoutAction = (navigate) => {
  return async (dispatch) => {
    dispatch({ type: type.USERLOGOUT });
    localStorage.removeItem("token");
    sessionStorage.clear();
    navigate("/");
  };
};

const manageUserSetting = (token, keyPath, value) => {
  return async function (dispatch) {
    const validToken = token || localStorage.getItem("token");
    manageUserSettingHandle(validToken, { keyPath, value }).then((data) => {
      if (data?.status === 200) {
      } else {
        dispatch({ type: type.USER_ERROR_HANDLER, payload: data });
      }
    });
  };
};

const manageDashboardTags = (token, state) => {
  return async function (dispatch) {
    const tokens = state?.wishListDataTemp?.map((item) =>
      JSON.parse(item?.token)
    );
    let bodyData = {
      tokens,
      chartView: state?.chartView,
      timeFrame: state?.chartDuration[state?.chartView]?.timeFrame,
      interval: state?.chartDuration[state?.chartView]?.interval,
    };
    dashboardStocksTagsHandle(token, bodyData).then((data) => {
      if (data?.status === 200) {
        const tagsData =
          data?.data?.map((item) => ({
            token: item?.token,
            tag: item?.tag,
          })) ?? [];
        dispatch(manageStocksTagsAction(tagsData || []));
        if (state?.sorting["Dashboard"]?.tags?.length > 0) {
          dispatch(
            dashboardSortTagAction({ tags: state?.sorting["Dashboard"]?.tags })
          );
        }
      } else {
        dispatch({ type: type.USER_ERROR_HANDLER, payload: data });
      }
    });
  };
};

const UserLoginFetch = (payload) => ({
  type: type.fetchAdminLoginSuccess,
  payload,
});

const GetGraphTypeAction = (payload) => ({
  type: type.graphType,
  payload,
});

const GetGraphStyleAction = (payload) => ({
  type: type.graphStyle,
  payload,
});

const UserLogOutAction = (payload) => ({
  type: type.AdminlogOutSuccess,
  payload,
});

// User profile Function
const PostUserProfile = (payload, token, setError) => {
  return async function (dispatch) {
    PostUserProfileApiHandle(payload, token).then((data) => {
      if (data.status === 200) {
        dispatch({ type: type.EDIT_PROFILE, payload: data });
      } else {
        dispatch({ type: type.USER_ERROR_HANDLER, payload: data });
        // Index.toast.error(data.message);
        setError(data.message);
      }
    });
  };
};

const getUserSettings = async (dispatch, token, setTheme, rowData, size) => {
  try {
    let data = rowData ?? {};

    if (!rowData) {
      const validToken = token || localStorage.getItem("token");
      const response = await Index.DataService(validToken).get(
        Index.Api.user.getSettings
      );
      data = response?.data?.data ?? {};
    }

    setTheme(data?.theme || "Light");

    const defaultDisplaySettings = {
      ScriptDetails: "on",
      cmp: "on",
      change_in_rs: "on",
      change_in_percentage: "on",
      TimeScale: "on",
      PriceScale: "on",
      OrderPrice: "on",
      CursorTime: "on",
      OHLCValues: "on",
      Alerts: "on",
      StockName: "on",
      StockSymbol: "on",
      PriceIndicator: "on",
      UtilityBar: "right",
      StopLossTargetPrice: "on",
      LastUpdatedTime: "on",
      DaySplitter: "off",
      AutoSquare: "on",
    };

    let payload = {
      ...data,
      rowsPerPage: data?.rowsPerPage || 10,
      displaySettings: {
        ...defaultDisplaySettings,
        ...(data?.displaySetting || {}),
      },
      otherSettings: data?.colorSetting,
      chartDefaultSettings: {
        ...data?.chartSetting,
        chartView: data?.chartView,
      },
      drawingToolSetting: {
        fillColor: data?.drawingToolSetting?.fillColor || "#e06666",
        strokeColor: data?.drawingToolSetting?.strokeColor || "#e06666",
        thickness: data?.drawingToolSetting?.thickness || 1,
      },
    };

    if (size?.width < 992) {
      if (payload) {
        const isLandscapeMode = size?.width > size?.height;
        if (isLandscapeMode) {
          payload.gridView = { column: 1, row: 1 };
        } else {
          payload.gridView = { column: 2, row: 1 };
        }
      }
    }

    delete payload?._id;
    delete payload?.userId;
    delete payload?.displaySetting;
    delete payload?.colorSetting;
    delete payload?.chartSetting;
    delete payload?.isDeleted;
    delete payload?.createdAt;
    delete payload?.updatedAt;

    dispatch(manageSettings(payload));
  } catch (error) {}
};

const getAllShortcuts = (payload, token) => {
  return async function (dispatch) {
    GetAllShortcuts(payload, token).then((data) => {
      if (data) {
        dispatch({ type: type.GETALLSHORTCUTS, payload: data });
      } else {
        dispatch({ type: type.USER_ERROR_HANDLER, payload: data });
        // Index.toast.error(data.message);
      }
    });
  };
};

const getAngelListData = (payload) => {
  return {
    type: type.angelListData,
    payload,
  };
};
const getWishListData = (payload) => {

const updatedPayload = payload.filter(
  (pay) => pay.name !== "MCXBULLDEX" && pay.name !== "MCXMETLDEX"
);

  return {
    type: type.wishListData,
    payload:updatedPayload,
  };
};
const deleteWishListData = (payload) => {
  return {
    type: type.wishListDataRemove,
    payload,
  };
};
const viewWishListData = (payload) => {
  return {
    type: type.wishListDataView,
    payload,
  };
};
const setChartDuration = (payload) => {
  return {
    type: type.setChartDuration,
    payload,
  };
};
const setTimeFrame = (payload) => {
  return {
    type: type.timeFrame,
    payload,
  };
};

const showHeaderSearchBar = (payload) => {
  return {
    type: type.headerSearchBar,
    payload,
  };
};

const showDefaultSettingModal = (payload) => {
  return {
    type: type.defaultSettingModal,
    payload,
  };
};

const setChartView = (payload) => {
  return {
    type: type.chartView,
    payload,
  };
};
const setLiveData = (payload) => {
  return {
    type: type.liveData,
    payload,
  };
};
const setGridViewStore = (payload) => {
  return {
    type: type.gridView,
    payload,
  };
};

const pageSetting = (payload) => {
  return {
    type: type.pageSetting,
    payload,
  };
};

const activeShortCut = (payload) => {
  return {
    type: type.activeShortCut,
    payload,
  };
};

const currentPagePlus = (payload) => {
  return {
    type: type.currentPagePlus,
    payload,
  };
};

const currentPageMinus = (payload) => {
  return {
    type: type.currentPageMinus,
    payload,
  };
};

const sortWishListData = (payload) => {
  return {
    type: type.sortingWishList,
    payload,
  };
};

const getAllTagsList = (payload) => {
  return {
    type: type.getTagListAll,
    payload,
  };
};

const manageCurrentTag = (payload) => {
  return {
    type: type.MANAGE_CURRENT_TAG,
    payload,
  };
};

const manageGridSpacing = (payload) => {
  return {
    type: type.MANAGE_GRID_SPACING,
    payload,
  };
};

const manageGridBorder = (payload) => {
  return {
    type: type.MANAGE_GRID_BORDER,
    payload,
  };
};

const manageGridColor = (payload) => {
  return {
    type: type.MANAGE_GRID_COLOR,
    payload,
  };
};

const manageScript = (payload) => {
  return {
    type: type.SELECTED_SCRIPT,
    payload,
  };
};

const manageOtherSetting = (payload) => {
  return {
    type: type.OTHER_SETTING,
    payload,
  };
};
const manageDisplaySettings = (payload) => {
  return {
    type: type.DISPLAY_SETTINGS,
    payload,
  };
};

const manageChartDrawingData = (payload) => {
  return {
    type: type.DRAW_CHART,
    payload,
  };
};

const manageActiveChartHoverData = (payload) => {
  return {
    type: type.ACTIVE_CHART_HOVER,
    payload,
  };
};

const manageTrackingActiveChartHoverData = (payload) => {
  return {
    type: type.TRACKING_ACTIVE_CHART_HOVER,
    payload,
  };
};

const manageDownloadChartData = (payload) => {
  return {
    type: type.DOWNLOAD_CHART_TOKEN,
    payload,
  };
};

const manageMiniChartSize = (payload) => {
  return {
    type: type.MINI_CHART_SIZE,
    payload,
  };
};

const manageDrawingButton = (payload) => {
  return {
    type: type.SHOW_HIDE_DRAWING_BUTTON,
    payload,
  };
};

const manageDrawingToolActiveDeactive = (payload) => {
  return {
    type: type.DRAWING_TOOL_ACTIVE_DEACTIVE,
    payload,
  };
};
const manageDrawingToolsList = (payload) => {
  return {
    type: type.DRAWING_TOOLS_LIST,
    payload,
  };
};

const manageToolOrientation = (payload) => {
  return {
    type: type.TOOL_ORIENTATION,
    payload,
  };
};

const manageChartInstance = (payload) => {
  return {
    type: type.CHART_INSTANCE,
    payload,
  };
};

const manageResetState = (payload) => {
  return {
    type: type.RESET_STATE,
    payload,
  };
};

const manageFlip = (payload) => {
  return {
    type: type.FLIP_STATE,
    payload,
  };
};

const manageRowsPerPage = (payload) => {
  return {
    type: type.ROWS_PER_PAGE,
    payload,
  };
};

const manageCategoryFilter = (payload) => {
  return {
    type: type.CATEGORY_FILTER,
    payload,
  };
};

const changeChartView = () => {
  return {
    type: type.CHART_VIEW_STATE,
  };
};

const manageDefaultSetting = (payload) => {
  return {
    type: type.DEFAULT_SETTINGS,
    payload,
  };
};

const manageSortingTags = (payload) => {
  return {
    type: type.SORTING_TAGS,
    payload,
  };
};

const manageCustomScript = (payload) => {
  return {
    type: type.CUSTOM_SCRIPTS,
    payload,
  };
};

const manageExitAllModal = (payload) => {
  return {
    type: type.EXIT_ALL_MODAL,
    payload,
  };
};

const manageListSettings = (payload) => {
  return {
    type: type.LIST_SETTINGS,
    payload,
  };
};

const manageTaggedStocksCount = (payload) => {
  return {
    type: type.TAGGED_STOCKS_COUNT,
    payload,
  };
};

const manageSidebarVisibility = (payload) => {
  return {
    type: type.SIDEBAR_VISIBILITY,
    payload,
  };
};

const manageModalParameter = (payload) => {
  return {
    type: type.MODAL_PARAMETERS,
    payload,
  };
};

const manageTwoSideArrowZoom = (payload) => {
  return {
    type: type.TWO_SIDE_ARROW_ZOOM,
    payload,
  };
};

const manageEraseDrawing = (payload) => {
  return {
    type: type.ERASE_DRAWING,
    payload,
  };
};

const manageCurrentPage = (payload) => {
  return {
    type: type.CURRENT_PAGE,
    payload,
  };
};

const manageSorting = (payload) => {
  return {
    type: type.SORTING,
    payload,
  };
};

const manageTrackingStocks = (payload) => {
  return {
    type: type.TRACKING_WINDOW_STOCKS,
    payload,
  };
};

const manageDrawingChartToken = (payload) => {
  return {
    type: type.DRAWING_CHART_TOKEN,
    payload,
  };
};

const manageNotificationCount = (payload) => {
  return {
    type: type.NOTIFICATION_COUNT,
    payload,
  };
};

const manageDefaultTheme = (payload) => {
  return {
    type: type.DEFAULT_THEME,
    payload,
  };
};

const manageSettings = (payload) => {
  return {
    type: type.MANAGE_SETTINGS,
    payload,
  };
};

const manageAutoSquareTime = (payload) => {
  return {
    type: type.MANAGE_AUTO_SQUARE_TIME,
    payload,
  };
};

const manageDrawingToolSetting = (payload) => {
  return {
    type: type.MANAGE_DRAWING_TOOL_SETTING,
    payload,
  };
};

// const manageStopLossTargetAction = () => {
//   return {
//     type: type.MANAGE_STOPLOSS_TARGET_ACTION,
//   };
// };
const manageStopLossAction = (payload) => {
  return {
    type: type.MANAGE_STOPLOSS_ACTION,
    payload
  };
};
const manageTargetAction = (payload) => {
  return {
    type: type.MANAGE_TARGET_ACTION,
    payload
  };
};
const dashboardSortTagAction = (payload) => {
  return {
    type: type.DASHBOARD_SORT_TAG,
    payload,
  };
};

const manageStocksTagsAction = (payload) => {
  return {
    type: type.MANAGE_STOCKS_TAGS,
    payload,
  };
};

const manageChartZoomAction = (payload) => {
  return {
    type: type.CHART_ZOOM,
    payload,
  };
};

const manageFocusedComponent = (payload) => {
  return {
    type: type.FOCUSED_COMPONENT,
    payload,
  };
};

const manageSelectedMarketData = (payload) => {
  return {
    type: type.SELECTED_MARKET,
    payload,
  };
};

export {
  UserLoginFetch,
  UserLogOutAction,
  UserLogin,
  GetGraphTypeAction,
  UserLogoutAction,
  GetGraphStyleAction,
  PostUserProfile,
  getAngelListData,
  getWishListData,
  setChartDuration,
  setTimeFrame,
  showHeaderSearchBar,
  showDefaultSettingModal,
  setChartView,
  setLiveData,
  setGridViewStore,
  pageSetting,
  getAllShortcuts,
  activeShortCut,
  currentPagePlus,
  currentPageMinus,
  deleteWishListData,
  viewWishListData,
  sortWishListData,
  getAllTagsList,
  manageCurrentTag,
  manageGridBorder,
  manageGridSpacing,
  manageGridColor,
  manageScript,
  manageOtherSetting,
  manageDisplaySettings,
  manageChartDrawingData,
  manageActiveChartHoverData,
  manageTrackingActiveChartHoverData,
  manageDownloadChartData,
  manageMiniChartSize,
  manageDrawingButton,
  manageDrawingToolActiveDeactive,
  manageDrawingToolsList,
  manageToolOrientation,
  manageChartInstance,
  manageResetState,
  manageFlip,
  manageRowsPerPage,
  manageCategoryFilter,
  changeChartView,
  manageDefaultSetting,
  manageSortingTags,
  manageCustomScript,
  manageExitAllModal,
  manageListSettings,
  manageTaggedStocksCount,
  manageSidebarVisibility,
  manageModalParameter,
  manageTwoSideArrowZoom,
  manageEraseDrawing,
  manageCurrentPage,
  manageSorting,
  manageTrackingStocks,
  manageDrawingChartToken,
  manageNotificationCount,
  manageUserSetting,
  manageDefaultTheme,
  manageSettings,
  getUserSettings,
  manageAutoSquareTime,
  manageDrawingToolSetting,
  // manageStopLossTargetAction,
  manageStopLossAction,
  manageTargetAction,
  dashboardSortTagAction,
  manageStocksTagsAction,
  manageDashboardTags,
  manageChartZoomAction,
  manageFocusedComponent,
  manageSelectedMarketData,
};
